import './styles.css';

const Field = ({
  label,
  value,
}: {
  label: string;
  value?: string | number | null;
}) => (
  <div className="field">
    <p className="field-label">{label}</p>
    <p className="field-value">{value || "-"}</p>
  </div>
);

export default Field;